"use client"

import Image from "next/image"

type StorefrontLogoProps = {
  brandName?: string | null
  logoUrl?: string | null
  width: number
  height: number
  className?: string
  textClassName?: string
  priority?: boolean
  sizes?: string
}

const DEFAULT_BRAND_NAME = ""

function classNames(...values: Array<string | undefined | false | null>) {
  return values.filter(Boolean).join(" ")
}

export default function StorefrontLogo({
  brandName,
  logoUrl,
  width,
  height,
  className,
  textClassName,
  priority,
  sizes,
}: StorefrontLogoProps) {
  const resolvedName = typeof brandName === "string" && brandName.trim() ? brandName.trim() : DEFAULT_BRAND_NAME
  const resolvedLogo = typeof logoUrl === "string" && logoUrl.trim() ? logoUrl.trim() : null

  if (resolvedLogo) {
    return (
      <Image
        src={resolvedLogo}
        alt={resolvedName}
        width={width}
        height={height}
        className={className}
        priority={priority}
        sizes={sizes}
      />
    )
  }

  return <span className={classNames(className, textClassName)}>{resolvedName}</span>
}
